import { SenderState } from '../enums/senderState';
import { SecurityContextType } from '../enums/securityContextType';

export enum UserType {
  User = 1,
  Admin = 2,
  SuperTeacher = 3,
  Teacher = 4,
  Student = 8,
  Parent = 16,
  ProgramAdmin = 32,
  ProgramUser = 64,
  Guest = 128,
  SuperAdmin = 264,
  GroupUser = 512
}

export interface ILoginAnnouncementModel {
  senderState: SenderState;
  announcementId: string;
  contextType: SecurityContextType;
  contextId: string;
  fromDisplayName: string;
  subject: string;
  body: string;
  showOnStartup: true | false;
  startDate: date;
  endDate: date;
}

export interface ILoginAnnouncementByIdModel {
  targets: Array<
    {
      userType: number;
      contextId: string;
      contextType: number;
    }
  >;
  files: Array<{
    fileName: any;
    size: any;
    ownerId: any;
    createdDate: any;
    path: any;
  }>;
  fromDisplayName: string;
  subject: string;
  body: string;
  smsBody: string;
  isShowOnStartUp: boolean;
  showReadConfirmation: boolean;
  senderState: any;
  smsTargetSize: any;
  emailTargetSize: any;
  webTargetSize: any;
  startDate: Date;
  endDate: Date;
  fromAvatarPath: any;
  announcementId: string;
  content: string;
  fileUploadKey: string;
  isSms: boolean;
  isEmail: boolean;
  isNotification: boolean;
  isPin: boolean;
  isRead: boolean;
  totalCount: number;
  contextHeaders: Array<any>;
  createdDate: Date;
}